import type { I18nFn } from '#/i18n/types/I18nFn';

export enum ListingStatus {
  DELETED = 'DELETED',
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  ARCHIVED = 'ARCHIVED',
  FROZEN = 'FROZEN',
  HIDDEN = 'HIDDEN',
  CHECKOUT = 'CHECKOUT',
  INVOICE = 'INVOICE',
  PULLED = 'PULLED',
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SPAM = 'SPAM',
}

export function STATUSES(i18n: I18nFn) {
  return {
    DELETED: i18n('Deleted'),
    PUBLISHED: i18n('Published'),
    DRAFT: i18n('Draft'),
    ARCHIVED: i18n('Expired'),
    FROZEN: i18n('Frozen'),
    HIDDEN: i18n('Hidden'),
    CHECKOUT: i18n('In Cart'),
    INVOICE: i18n('Invoiced'),
    PULLED: i18n('Pulled from site'),
    APPROVED: i18n('Approved'),
    PENDING: i18n('Pending'),
    REJECTED: i18n('Rejected'),
    SPAM: i18n('Spam'),
  } as const;
}

export function STATUS_CHECKBOX_OPTIONS(i18n: I18nFn) {
  return Object.entries(STATUSES(i18n)).map(([key, value]) => ({
    name: key,
    label: value,
  }));
}
